import { ElMessage } from 'element-plus'

export default class ElementDdExtension {
  private _message = ElMessage

  public showSuccess(message: string): any {
    return this._message({
      type: 'success',
      message,
      offset: 20, // Element UI's; Element Plus defaults to 16
    })
  }

  public showError(message: string): any {
    return this._message({
      type: 'error',
      message,
      offset: 20,
    })
  }

  public showGenericError(): any {
    return this._message({
      type: 'error',
      message: 'Something went wrong! Please try again.',
      offset: 20,
    })
  }
}
